import app from './app/reducer';
import auth from './auth/reducer';
import config from './config/reducer';
import device from './device/reducer';
import intl from './intl/reducer';
import themes from './themes/reducer';
import users from './users/reducer';
import properties from './properties/reducer';
import { combineReducers } from 'redux';
import { fieldsReducer as fields } from './lib/redux-fields';

// stackoverflow.com/q/35622588/233902
// TODO - erase this I think
/*
const resetStateOnSignOutReducer = (reducer, initialState) => (
  state: State,
  action: Action,
) => {
  const userWasSignedOut =
    action.type === 'ON_AUTH' &&
    state.users.viewer &&
    !action.payload.firebaseUser;

  if (!userWasSignedOut) {
    return reducer(state, action);
  }
  // Reset app state to purge all sensitive data.
  return reducer({
    // app: state.app,
    app: state.app,
    config: initialState.config,
    device: initialState.device,
    intl: initialState.intl,
  }, action);
};
*/

const configureReducer = (/* initialState: Object */) => {
  const reducer = combineReducers({
    app,
    auth,
    config,
    device,
    fields,
    intl,
    themes,
    users,
    properties,
  });

  // The power of higher-order reducers, http://slides.com/omnidan/hor
  // reducer = resetStateOnSignOutReducer(reducer, initialState);

  return reducer;
};

export default configureReducer;



// WEBPACK FOOTER //
// ./src/common/configureReducer.js